module.exports = __webpack_public_path__ + "static/imgpsh_fullsize_anim-bcf794d1aea3e0b5ff698125671be14c.jpg";